"use client"

import type { Dispatch, ReactNode, SetStateAction } from "react"
import type { ShoppingCart } from "#models/shopping/shoppingCart"

import { createContext, useContext, useState } from "react"

const shoppingContext = createContext<ReturnType<typeof useCreateShoppingContext>>(null!)

function useCreateShoppingContext() {
  const [cartPopupOpen, setCartPopupOpen] = useState(false)

  // TODO DEV-157 PROBLEM: Using useState instead of useOptimistic here because for whatever reason the context is being re-rendered when navigating during an action (add or remove from cart), therefore using useOptimistic with undefined to work with suspense leads to clearing the optimistic cart - this leads to loosing the state and showing old suspense content that isnt optimistic, furthermore the ui doesnt update automatically when the server action is done, the suspense server components arent re-fetched, therefore an old state is shown... to reproduce this behavoir add await sleep(5000) to the beginning of the addCartItem server action in cart.serverAction.ts, then go to artwork page and click add to cart, during the 5s load, navigate to the cart via the cart popup, the cart will lose the optimistic state and show the old server rendered content, after that no content is automatically updated until page refresh

  // OLD, not working in next 14, Self clearing optimistic cart - clears the value itself (since the initial is undefined) so that the UI can fall back to the fresh server renderer content again - this is used to work with suspense rendered content
  const [optimisticCart, setOptimisticCart] = useState<ShoppingCart | undefined>(undefined)

  return {
    cartPopupOpen,
    setCartPopupOpen,
    optimisticCart: optimisticCart,
    setOptimisticCart: ((...args: any[]) => {
      //@ts-ignore
      setOptimisticCart(...args)
    }) as Dispatch<SetStateAction<ShoppingCart | undefined | null>>,
  }
}

export function ShoppingContext({ children }: { children: ReactNode }) {
  const contextValue = useCreateShoppingContext()

  return <shoppingContext.Provider value={contextValue}>{children}</shoppingContext.Provider>
}

export function useShoppingContext() {
  return useContext(shoppingContext)
}
